import { ProductCardAnimation } from 'product-card/types'
import { createContext, type ReactNode, useMemo } from 'react'

export interface ProductCardAnimationContextProps {
	animation: ProductCardAnimation
	onAnimationEnd?: () => void
}

interface ProductCardAnimationProviderProps {
	readonly animation: ProductCardAnimation
	readonly onAnimationEnd?: () => void
	readonly children: ReactNode
}

const defaultContext: ProductCardAnimationContextProps = {
	animation: ProductCardAnimation.FadeIn,
}

export const ProductCardAnimationContext = createContext(defaultContext)

export const ProductCardAnimationProvider = ({
	animation,
	onAnimationEnd,
	children,
}: ProductCardAnimationProviderProps) => {
	const values = useMemo(
		() => ({ animation, onAnimationEnd }),
		[animation, onAnimationEnd]
	)
	return (
		<ProductCardAnimationContext.Provider value={values}>
			{children}
		</ProductCardAnimationContext.Provider>
	)
}
